/* Native filter links remain usable without JavaScript or if a request fails. */
(() => {
  if (window.morrisRiserMenuLoaded) return;
  window.morrisRiserMenuLoaded = true;
  const desktop = window.matchMedia('(min-width: 1025px)');
  const hover = window.matchMedia('(hover: hover) and (pointer: fine)');
  let appliedLocation = location.pathname + location.search;
  const finderSelector = '[data-riser-menu], [data-collection-finder]';
  function prepareCollectionLinks(panel) {
    const current = new URL(location.href);
    panel.querySelectorAll('a[data-riser-filter], a[data-riser-results]').forEach(link => {
      const url = new URL(link.getAttribute('href'), location.origin);
      // A new selection starts on page one but keeps the shopper's display choices.
      url.searchParams.delete('page');
      url.searchParams.delete('section_id');
      for (const key of ['sort_by', 'view', 'preview_theme_id']) {
        if (current.searchParams.has(key) && !url.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
      }
      url.hash = 'product-grid';
      link.href = url.href;
    });
  }
  function initialise(root = document) {
    const finders = Array.from(root.querySelectorAll(finderSelector));
    if (root.matches?.(finderSelector)) finders.unshift(root);
    finders.forEach(menu => {
      if (menu.dataset.ready) return;
      menu.dataset.ready = 'true';
      const inline = menu.hasAttribute('data-collection-finder');
      const trigger = menu.querySelector('[data-riser-trigger]');
      const toggle = menu.querySelector('[data-riser-toggle]');
      const control = toggle || trigger;
      const popover = inline ? menu : menu.querySelector('.ml-riser-popover');
      const status = menu.querySelector('[data-riser-status]');
      let leaveTimer;
      let pending = false;
      let refreshHref = null;
      let needsLoad = menu.hasAttribute('data-needs-load');
      let isOpen = inline;
      if (inline) {
        menu.querySelector('[data-collection-details]').removeAttribute('open');
        prepareCollectionLinks(menu);
        appliedLocation = location.pathname + location.search;
        // Native price/sort controls replace the collection section. Refresh the
        // matching header finder from that same URL when it is next opened.
        document.querySelectorAll('[data-riser-menu]').forEach(header => {
          if (header.dataset.menuKey === menu.dataset.menuKey) {
            header.dispatchEvent(new CustomEvent('riser-source-change', { detail: location.href }));
          }
        });
        menu.addEventListener('finder-reset', () => {
          if (pending) refreshHref = location.href;
          else updatePanel(location.href, null, false);
        });
      }
      const close = (restoreFocus = false) => {
        clearTimeout(leaveTimer);
        isOpen = false;
        menu.removeAttribute('data-open');
        control.setAttribute('aria-expanded', 'false');
        popover.hidden = true;
        if (restoreFocus) control.focus({ preventScroll: true });
      };
      const open = () => {
        if (isOpen) return;
        document.querySelectorAll('[data-riser-menu]').forEach(other => {
          if (other !== menu) other.dispatchEvent(new Event('riser-close'));
        });
        isOpen = true;
        menu.setAttribute('data-open', '');
        control.setAttribute('aria-expanded', 'true');
        popover.hidden = false;
        if (needsLoad && !pending) updatePanel(menu.dataset.baseUrl, null, false);
      };
      if (!inline) {
        menu.addEventListener('riser-source-change', event => {
          menu.dataset.baseUrl = event.detail;
          needsLoad = true;
          if (pending) refreshHref = event.detail;
          else if (isOpen) updatePanel(event.detail, null, false);
        });
        menu.addEventListener('riser-close', () => close());
        // Keep the label as a normal link to the unfiltered collection.
        // Only the adjacent button toggles the finder (including on touch).
        toggle?.addEventListener('click', () => {
          if (isOpen) close(); else open();
        });
        const openWithArrow = event => {
          if (event.key === 'ArrowDown') {
            event.preventDefault();
            open();
            popover.querySelector('a,button')?.focus();
          }
        };
        trigger.addEventListener('keydown', openWithArrow);
        toggle?.addEventListener('keydown', openWithArrow);
        menu.addEventListener('pointerenter', () => {
          clearTimeout(leaveTimer);
          if (desktop.matches && hover.matches) open();
        });
        menu.addEventListener('pointerleave', () => {
          if (desktop.matches && hover.matches) {
            leaveTimer = setTimeout(() => {
              if (!menu.contains(document.activeElement)) close();
            }, 240);
          }
        });
        menu.addEventListener('focusout', () => {
          setTimeout(() => {
            if (desktop.matches && !menu.contains(document.activeElement) && !menu.matches(':hover')) close();
          }, 0);
        });
        menu.addEventListener('keydown', event => {
          if (event.key === 'Escape' && isOpen) {
            event.preventDefault();
            event.stopPropagation();
            close(true);
          }
        });
        document.addEventListener('click', event => {
          if (!menu.contains(event.target)) close();
        });
      }
      menu.addEventListener('click', event => {
        if (pending && event.target.closest('[data-riser-results]')) {
          event.preventDefault();
          return;
        }
        if (event.target.closest('[data-riser-close]')) {
          close(true);
          return;
        }
        const link = event.target.closest('a[data-riser-filter]');
        if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const target = new URL(link.href, location.origin);
        if (target.origin !== location.origin) return;
        event.preventDefault();
        if (!pending) updatePanel(link.href, link.dataset.focusKey, true);
      });
      async function updatePanel(href, focusKey, navigateOnFailure) {
        const target = new URL(href, location.origin);
        const oldPanel = menu.querySelector('[data-riser-panel]');
        const scrollPositions = new Map(Array.from(oldPanel.querySelectorAll('[data-scroll-key]'), el => [el.dataset.scrollKey, el.scrollTop]));
        const panelScroll = popover.scrollTop;
        const drawer = menu.closest('.navigation__menu-content');
        const drawerScroll = drawer?.scrollTop;
        target.searchParams.set('section_id', inline ? 'morris-collection-filters' : 'morris-riser-finder');
        const preview = new URL(location.href).searchParams.get('preview_theme_id');
        if (preview) target.searchParams.set('preview_theme_id', preview);
        pending = true;
        menu.setAttribute('aria-busy', 'true');
        status.textContent = 'Updating matching chairs…';
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 10000);
        try {
          const response = await fetch(target, { signal: controller.signal, credentials: 'same-origin' });
          if (!response.ok) throw new Error('Unable to load filters');
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          if (!menu.isConnected || refreshHref) return;
          const panel = html.querySelector('[data-riser-panel]');
          if (!panel || panel.dataset.menuKey !== menu.dataset.menuKey || !/^\d+$/.test(panel.dataset.resultCount || '')) throw new Error('Missing filter section');
          const restoreFocus = focusKey && isOpen && oldPanel.contains(document.activeElement);
          const restoreSummaryFocus = inline && document.activeElement === oldPanel.querySelector('summary');
          if (inline) {
            prepareCollectionLinks(panel);
            // Keep the shopper's current expansion state while replacing both
            // filter choices and the header's latest apply/reset destinations.
            panel.querySelector('[data-collection-details]').toggleAttribute('open', oldPanel.querySelector('[data-collection-details]').hasAttribute('open'));
          }
          oldPanel.replaceWith(panel);
          needsLoad = false;
          panel.querySelectorAll('[data-scroll-key]').forEach(el => {
            el.scrollTop = scrollPositions.get(el.dataset.scrollKey) || 0;
          });
          const focus = Array.from(panel.querySelectorAll('[data-focus-key]')).find(el => el.dataset.focusKey === focusKey);
          if (restoreSummaryFocus) panel.querySelector('summary').focus({ preventScroll: true });
          else if (restoreFocus) (focus || panel.querySelector('[data-riser-results]')).focus({ preventScroll: true });
          popover.scrollTop = panelScroll;
          if (drawer) drawer.scrollTop = drawerScroll;
          status.textContent = `${panel.dataset.resultCount} matching ${panel.dataset.resultNoun}.`;
        } catch {
          if (!menu.isConnected || refreshHref) return;
          if (navigateOnFailure) {
            // The normal Shopify page is also the functional no-JavaScript fallback.
            window.location.assign(href);
          } else {
            status.textContent = inline ? 'Use Apply filters to open the selected results.' : 'Use View all chairs to see every colour, material and range.';
          }
        } finally {
          clearTimeout(timeout);
          pending = false;
          menu.removeAttribute('aria-busy');
          if (refreshHref) {
            const href = refreshHref;
            refreshHref = null;
            needsLoad = true;
            if (menu.isConnected && (inline || isOpen)) updatePanel(href, null, false);
          }
        }
      }
    });
  }
  initialise();
  document.addEventListener('shopify:section:load', event => initialise(event.target));
  // Shopify's existing collection controls replace either the section or its
  // grid contents. Initialise only newly inserted finders, not every product.
  const collectionRoot = document.querySelector('main') || document.body;
  if (document.querySelector('[data-collection-finder]')) {
    new MutationObserver(records => {
      for (const record of records) for (const node of record.addedNodes) {
        if (node.nodeType === 1 && (node.matches('[data-collection-finder]') || node.querySelector('[data-collection-finder]'))) initialise(node);
      }
    }).observe(collectionRoot, { childList: true, subtree: true });
    window.addEventListener('popstate', () => {
      // The theme pushes native price/sort URLs without restoring HTML on Back.
      if (location.pathname + location.search !== appliedLocation) window.location.reload();
    });
    window.addEventListener('pageshow', event => {
      if (event.persisted) {
        // Cached pages may contain un-applied draft choices. The grid still
        // represents the URL, so restore the finder from that URL as well.
        document.querySelectorAll('[data-collection-finder]').forEach(finder => finder.dispatchEvent(new Event('finder-reset')));
      }
    });
  }
})();
